import React, { useState } from 'react';

const DownlinkTestPopupHOC = (Component:any) => 
function Comp(props:any){
    const [showDownlinkTestPopup,setShowDownlinkTestPopup] = useState<boolean>(false);

    const downlinkTestToggleHandler = () => {
        setShowDownlinkTestPopup(!showDownlinkTestPopup);
    }
	
	return <Component showDownlinkTestPopup={showDownlinkTestPopup} downlinkTestToggleHandler={downlinkTestToggleHandler} {...props}/>;
};

export default DownlinkTestPopupHOC;   